(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceDetailController', RaceDetailController);

    RaceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Race', 'Trainer', 'Schedule'];

    function RaceDetailController($scope, $rootScope, $stateParams, previousState, entity, Race, Trainer, Schedule) {
        var vm = this;

        vm.race = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:raceUpdate', function(event, result) {
            vm.race = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
